// src/components/home/HowItWorks/HowItWorks.jsx
import React from "react";
import { motion } from "framer-motion";
import {
  FiSearch,
  FiPhoneCall,
  FiCheckCircle,
  FiArrowUpRight,
} from "react-icons/fi";
import "./HowItWorks.css";
import whatsappLink from "../../utils/whatsappLink";
import visit from "../../utils/visit";

const STEPS = [
  {
    no: "01",
    icon: <FiSearch />,
    title: "Explore Properties",
    desc: "Browse verified listings, high-rise projects, and top locations that match your budget and lifestyle.",
  },
  {
    no: "02",
    icon: <FiPhoneCall />,
    title: "Visit & Consult",
    desc: "Schedule a visit or talk to our advisors. Get clarity on pricing, payment plans, and documentation.",
  },
  {
    no: "03",
    icon: <FiCheckCircle />,
    title: "Book with Confidence",
    desc: "We guide you through the final steps with transparent paperwork and a smooth closing process.",
  },
];

function StepCard({ step }) {
  return (
    <div className="hiwCard">
      <div className="hiwCard__top">
        <div className="hiwCard__no">{step.no}</div>
        <div className="hiwCard__icon">{step.icon}</div>
      </div>
      <h3 className="hiwCard__title">{step.title}</h3>
      <p className="hiwCard__desc">{step.desc}</p>
    </div>
  );
}

export default function HowItWorks() {
  return (
    <section className="hiw">
      <div className="container">
        <motion.div
          className="hiw__head"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div>
            <span className="hiw__kicker">Simple Process</span>
            <h2 className="hiw__title">How It Works</h2>
            <p className="hiw__sub">
              A clear 3-step flow to help you move from browsing to
              booking—without confusion.
            </p>
          </div>

          <a
            target="_blank"
            href={visit()}
          >
            <button className="hiw__cta" type="button">
              Book a Visit <FiArrowUpRight />
            </button>
          </a>
        </motion.div>

        <div className="hiw__grid">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.no}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.06 }}
            >
              <StepCard step={s} />
            </motion.div>
          ))}
        </div>

        <div className="hiw__note">
          <span className="hiw__noteBadge">Pro Tip</span>
          <p className="hiw__noteText">
            If you’re investing, ask for rental yield & future demand
            signals—we’ll guide you with practical market insight.
          </p>
        </div>
      </div>
    </section>
  );
}
